export default __webpack_public_path__ + "77274756d6c0502f7c62b4b7b0ae8021.svg";